import { render, staticRenderFns } from "./fccParametros.vue?vue&type=template&id=4bf42819"
import script from "./fccParametros.vue?vue&type=script&lang=js"
export * from "./fccParametros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports